import { BottomSheet, Text, Title, useModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { DialogContent, Stack } from "@mui/material";
import Confetti from "react-confetti";

import { DialogFooter } from "../redesign/components/DialogFooter";
import { WorkerBadgeImage } from "./BadgeImage";
import { BADGES_DATA, type BadgeType } from "./constants";

interface WorkerBadgeModalProps {
  badgeType: BadgeType;
  onClose: () => void;
}

export function WorkerBadgeModal(props: WorkerBadgeModalProps) {
  const { badgeType, onClose } = props;

  const modalState = useModalState("open");
  const badgeData = BADGES_DATA[badgeType];

  if (!isDefined(badgeData)) {
    return null;
  }

  // this is needed to make sure closing the modal via backdrop calls onClose
  modalState.closeModal = () => {
    onClose();
    modalState.setModalStatus("closed");
  };

  return (
    <BottomSheet
      modalState={modalState}
      paperSx={{
        overflow: "hidden",
      }}
      footer={
        <DialogFooter
          orientation="vertical"
          onClose={() => {
            modalState.closeModal();
          }}
        />
      }
    >
      <DialogContent>
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={100}
          gravity={0.2}
        />

        <Stack
          spacing={6}
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            paddingTop: 8,
          }}
        >
          <Text semibold variant="h3" sx={{ paddingBottom: 6, textWrap: "balance" }}>
            You&apos;ve earned a new badge!
          </Text>

          <WorkerBadgeImage imageUrl={badgeData.image} alt={badgeData.title} />

          <Title semibold component="h2" variant="h4" sx={{ paddingTop: 6 }}>
            {badgeData.title}
          </Title>

          <Text variant="body1">{badgeData.description}</Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
